var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_308",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8188",
    "data-name": "Rectangle 8188",
    width: 35.644,
    height: 35.644,
    fill: "none",
    stroke: "#007ab9",
    strokeWidth: 2.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28878",
    "data-name": "Group 28878",
    transform: "translate(-508 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27963",
    "data-name": "Group 27963",
    transform: "translate(517 257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28370",
    "data-name": "Group 28370",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_308)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308-2",
    "data-name": "Ellipse 308",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28842",
    "data-name": "Group 28842",
    transform: "translate(524 264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27960",
    "data-name": "Group 27960",
    transform: "translate(2.756 3.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27959",
    "data-name": "Group 27959",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27958",
    "data-name": "Group 27958",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27957",
    "data-name": "Group 27957",
    transform: "translate(1.044 1.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49095",
    "data-name": "Path 49095",
    d: "M48.555,31.778A16.778,16.778,0,1,1,31.778,15,16.778,16.778,0,0,1,48.555,31.778Z",
    transform: "translate(-15 -15)",
    fill: "none",
    stroke: "#264151",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49096",
    "data-name": "Path 49096",
    d: "M115.512,126.024a10.512,10.512,0,1,1,10.512-10.512A10.524,10.524,0,0,1,115.512,126.024Z",
    transform: "translate(-98.735 -98.735)",
    fill: "none",
    stroke: "#264153",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49097",
    "data-name": "Path 49097",
    d: "M199.247,203.493a4.247,4.247,0,1,1,4.247-4.247A4.251,4.251,0,0,1,199.247,203.493Z",
    transform: "translate(-182.469 -182.469)",
    fill: "#007ab9",
    stroke: "#007ab9",
    strokeWidth: 2.5
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49098",
    "data-name": "Path 49098",
    d: "M256,66.234v-6.27",
    transform: "translate(-235.422 -52.128)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49099",
    "data-name": "Path 49099",
    d: "M361.964,256h6.27",
    transform: "translate(-334.009 -234.517)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49100",
    "data-name": "Path 49100",
    d: "M66.234,256h-6.27",
    transform: "translate(-53.033 -234.517)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49101",
    "data-name": "Path 49101",
    d: "M256.444-46.322v-6.27",
    transform: "translate(-235.835 52.592)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49102",
    "data-name": "Path 49102",
    d: "M462.408,253.444h6.27",
    transform: "translate(-427.461 -232.139)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49103",
    "data-name": "Path 49103",
    d: "M256.444,459.408v6.271",
    transform: "translate(-235.835 -423.764)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49105",
    "data-name": "Path 49105",
    d: "M256.444,459.408v6.271",
    transform: "translate(-235.866 -431.484)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49104",
    "data-name": "Path 49104",
    d: "M-33.322,253.444h-6.27",
    transform: "translate(39.592 -232.139)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.292e3dcbeeefa40e7ba80839e27d6069.svg";
export { ForwardRef as ReactComponent };